import { createContext, useContext, useState } from "react";

export const UserContext = createContext(undefined);

export const UserContextProvider = ({
    children,
}) => {
    const [data, setData] = useState(null);

    return (
        <UserContext.Provider
            value={{
                data,
                setData
            }}
        >
            {children}
        </UserContext.Provider>
    );
};

export const useUserContext = () => {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error(
            "useUserContext must be used within an UserContextProvider"
        );
    }
    return context;
};
